import { io, type Socket } from 'socket.io-client';

export interface StatusPedidoEvento {
  /** UUID do pedido_cardapio. */
  idPedidoCardapio: string;
  status: string;
}

let socket: Socket | null = null;

/**
 * Conecta o cliente Socket.IO autenticado pelo JWT do cliente delivery.
 * Reusa a conexão existente se já estiver aberta.
 */
export function conectarSocket(accessToken: string): Socket {
  if (socket && socket.connected) return socket;
  socket?.disconnect();
  socket = io({
    path: '/socket.io',
    auth: { token: accessToken },
    autoConnect: true,
    reconnection: true,
  });
  return socket;
}

export function desconectarSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function obterSocket(): Socket | null {
  return socket;
}
